// メッセージ種類
const MSG_TYPE = {
  SERIOUS: 0, //重大なエラー
  // page
  LOAD: 1, //読込失敗
  // sheet
  SHEET_LOAD: 11, //読込失敗
  SHEET_UPDATE: 12, //更新失敗
};

const ERR_MESSAGES = [
  // 重大なエラー
  {
    type: MSG_TYPE.SERIOUS,
    title: "エラーが発生しました",
    text: "大変申し訳ございませんが、お店までご連絡をお願いします。",
  },
  // 読込失敗(ページ)
  {
    type: MSG_TYPE.LOAD,
    title: "読込に失敗しました",
    text: "大変申し訳ございませんが、バツボタンを押してこの画面を閉じてください。",
  },
  // 読込失敗(シート)
  {
    type: MSG_TYPE.SHEET_LOAD,
    title: "読込に失敗しました",
    text: "大変申し訳ございませんが、バツボタンを押してこの画面を閉じてください。",
  },
  // 更新失敗(シート)
  {
    type: MSG_TYPE.SHEET_UPDATE,
    title: "更新に失敗しました",
    text: "更新に失敗しました。もう一度お願いします。",
  },
];
const MESSAGE_DEFAULT = ERR_MESSAGES[0]; //重大なエラー

class CommonError {
  constructor() { }

  findMessage (msgType) {
    const message = ERR_MESSAGES.find((message) => {
      return message.type == msgType;
    });
    if (!message) {
      return MESSAGE_DEFAULT;
    }
    return message;
  }
}
const commonError = new CommonError();

export { MSG_TYPE, commonError, ERR_MESSAGES };
